/* eslint-disable class-methods-use-this */

/**
 *
 * BreadCrumb
 *
 */
import React from 'react'
import { ThemeProvider } from 'styled-components'

import theme from '../../../utils/theme'
import BreadCrumbItem from './BreadCrumbItem'
import BreadCrumbWrapper from './BreadCrumbStyle'

class BreadCrumb extends React.Component {
  parseUrlStr(urlStr) {
    const urlStrArr = urlStr.split('/')
    let returnArr = []
    let itemStr = ''
    let itemPath = ''
    let isBackIcon = ''
    let backIconPath = ''

    if (urlStrArr[1] === 'memberships') {
      itemStr = 'Membership Dashboard'
      itemPath = '/memberships/dashboard'
      isBackIcon = true
      backIconPath = '/memberships/dashboard'
      returnArr = [
        {
          itemStr,
          itemPath,
          isBackIcon,
          backIconPath,
        },
      ]
    } else if (urlStrArr[1] === 'competitions') {
      itemStr = 'Competition Dashboard'
      itemPath = '/competitions/dashboard'
      isBackIcon = true
      backIconPath = '/competitions/dashboard'
      returnArr = [
        {
          itemStr,
          itemPath,
          isBackIcon,
          backIconPath,
        },
      ]
    }

    if (urlStrArr.length > 3) {
      if (urlStrArr[3]) {
        // eslint-disable-next-line prefer-destructuring
        itemStr = urlStrArr[3]
        itemPath = `/competitions/${urlStrArr[3]}`
        isBackIcon = false
        backIconPath = '/competitions/dashboard'
        returnArr.push({
          itemStr,
          itemPath,
          isBackIcon,
          backIconPath,
        })
      }
    }
    return returnArr
  }

  showBreadCrumbItems(urlStr) {
    const urlStrArr = this.parseUrlStr(urlStr)
    return urlStrArr.map((data, i) => {
      const nextIcon = urlStrArr.length - 1 !== i
      return (
        <BreadCrumbItem
          // biome-ignore lint/suspicious/noArrayIndexKey: TODO
          key={i}
          nextIconPath={data.itemPath}
          isNextIcon={nextIcon}
          isBackIcon={data.isBackIcon}
          backIconPath={data.backIconPath}
        >
          {data.itemStr}
        </BreadCrumbItem>
      )
    })
  }

  render() {
    const { to, className, ...rest } = this.props
    return (
      <ThemeProvider theme={theme}>
        <BreadCrumbWrapper className={className} {...rest}>
          {this.showBreadCrumbItems(to)}
        </BreadCrumbWrapper>
      </ThemeProvider>
    )
  }
}

BreadCrumb.defaultProps = {
  className: '',
}

export default BreadCrumb
